<template>
  <div class="px-2 w-full my-3">
    <div class="h-[1px] w-full bg-neutral-200" />
  </div>
</template>
